import React from 'react';
import { number, shape, string, node, oneOf, bool } from 'prop-types';
import { commitmentUnionTypes, getDurationUnit, getFieldValueByName, certificateUnionTypes, certificateTypeOptionList } from '@paddl/utils-js';
import { LogoCardWithText, CountryFlags } from '../../../..';
import { DetailsWrapper, CountryFlagWrapper } from '../../../Activity.styles';
import { getCommitment, getAttendanceCourse, getCountryIdByName } from '../../../../Utils/activities';
export const CertificateRead = _ref => {
  let {
    data: {
      details: {
        authority,
        certificate,
        certificateDuration,
        certificateType,
        commitment,
        location,
        attendanceOnline,
        attendanceInPerson
      }
    },
    editButton
  } = _ref;
  const FlagIcon = CountryFlags[getCountryIdByName(location)].icon;
  return /*#__PURE__*/React.createElement(DetailsWrapper, null, editButton, /*#__PURE__*/React.createElement("h1", {
    className: "headline"
  }, certificate.name), /*#__PURE__*/React.createElement(LogoCardWithText, {
    title: authority.name
  }), /*#__PURE__*/React.createElement(CountryFlagWrapper, null, /*#__PURE__*/React.createElement(FlagIcon, null), /*#__PURE__*/React.createElement("div", null, "".concat(location, " | ").concat(getFieldValueByName(certificateType, certificateTypeOptionList)))), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, "".concat(certificateDuration.value, "\n      ").concat(getDurationUnit(certificateDuration.unit, certificateDuration.value), "\n      \u2022 ").concat(getCommitment(commitment), "\n      \u2022 ").concat(getAttendanceCourse(attendanceOnline, attendanceInPerson))));
};
CertificateRead.propTypes = {
  data: shape({
    details: shape({
      authority: shape({
        id: number,
        name: string
      }).isRequired,
      certificate: shape({
        id: number,
        name: string
      }).isRequired,
      location: string,
      certificateType: oneOf(certificateUnionTypes),
      certificateDuration: shape({
        value: number,
        unit: string
      }).isRequired,
      commitment: oneOf(commitmentUnionTypes),
      attendanceOnline: bool,
      attendanceInPerson: bool
    }).isRequired
  }).isRequired,
  editButton: node
};
CertificateRead.defaultProps = {
  editButton: undefined
};